import React from 'react';
import {Divider, Typography} from '@mui/material';

import Container from '../../components/Container';
import Main from '../../layouts/Main';
import FeaturedForms from './components/FeaturedForms';
import PublicationList from './components/PublicationList';
import DisplayNewsletter from './components/DisplayNewsletter';
import { Subscription } from '../Home1/components';
import FeaturedVideos from './components/FeaturedVideos';
import PageBreadCrumbs from '../../components/PageBreadcrumbs';


const Publications = (): JSX.Element => {

  document.title = 'OCPF - Guides, Studies & Publications';

  return (
    <Main>
      <Container>
      <PageBreadCrumbs></PageBreadCrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            paddingBottom={2}
            >
            OCPF Forms & Publications
        </Typography>
        <Divider/>
        <FeaturedForms></FeaturedForms>
        <Divider/>
        <PublicationList></PublicationList>
        <Divider/>
        <FeaturedVideos></FeaturedVideos>
        <Divider />
        <DisplayNewsletter></DisplayNewsletter>
        <Subscription></Subscription>
      </Container>
    </Main>
  );
};

export default Publications;
